import React  from 'react'
import image1 from '../images/monictest.jpeg'
import { useNavigate } from "react-router-dom";

function Home() {
  const video1 = 'https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054186/tdrzoh9j6wzevlkczh7x.mp4'
  const video2 = 'https://res.cloudinary.com/ddluqpfwb/video/upload/v1787054196/olkqcqaz4zxhvbzqlxys.mp4'
  const navigate = useNavigate();

  return (
    <div>
        {/* <div className='hero-section'>
            <h1 className='hero-section-header'>Decor Delights & Events</h1>
            <h4 style={{ fontSize: '24px' }}>Luxury Event Planner</h4>
            <Button name="Contact Us" action={() => navigate("/contact")} />
        </div> */}

        <div className='section'>
          <div className='text-section'>
            <div className='text-content'>
              <h1 class="section-title">Services</h1>
              <p>At Decor Delights & Events, we provide premium event decoration services, specialising in corporate events, social celebrations, traditional weddings, and luxury weddings.</p>
              <p>Our team blends creative vision, elegant styling, and flawless execution to transform every venue into a stunning experience that leaves a lasting impression. Whether you're planning an intimate celebration or a large corporate function, we handle every decorative detail with precision to ensure your event is beautiful, memorable, and truly exceptional.</p>
              <div class="section-bottom-text" onClick={() => navigate("/services")}>
                <p>Explore Our Services</p>
              </div>
            </div>
          </div>

            <div className='image-section'>
              <video
                src={video1}
                autoPlay
                muted
                loop
                playsInline
                className='video-right'
              />
            </div>
        </div>

        <div className='section reverse'>
          <div className='image-section'>
            <video
                src={video2}
                autoPlay
                muted
                loop
                playsInline
                className='vid-left'
              />
          </div>

          <div className='text-section'>
            <div className='text-content'>
              <h1 class="section-title">Gallery</h1>
              <p>Explore our event gallery showcasing some of our finest creations for unforgettable occasions. See how Decor Delights & Events brings elegance, creativity, and flawless execution to every celebration.</p>
              <div class="section-bottom-text" onClick={() => navigate("/gallery")}>
                <p>View Photos</p>
              </div>
            </div>
          </div>
        </div>

        <div className='section'>
          <div className='text-section'>
            <div className='text-content'>
              <h1 class="section-title">Testimonials</h1>
              <p>"Thank you so much Decor Delights and Events for an excellent work, beautiful, epic and gorgeous. The environment commanded such a presence. God bless the work of your hands and expand you. Our hearts are full and thanks for being part of our story."</p>
              <p style={{fontStyle: 'italic'}}>Pastor Monicah K. </p>
              <div class="section-bottom-text" onClick={() => navigate("/testimonials")}>
                <p>More Testimonials</p>
              </div>
            </div>
          </div>

          <div className='image-section'>
            <img src={image1} alt="Event" className="carousel" />
          </div>
        </div>

    </div>
  )
}

export default Home

